<template>
  <span class="icon |" :class="classes">
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 14 27"
      style="enable-background:new 0 0 14 27;"
      xml:space="preserve"
    >
      <rect class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="1" y="1" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="2" y="2" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="3" y="3" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="4" y="4" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="5" y="5" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="6" y="6" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="7" y="7" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="8" y="8" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="9" y="9" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="10" y="10" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="11" y="11" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="12" y="12" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="13" y="13" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="12" y="14" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="11" y="15" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="10" y="16" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="9" y="17" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="8" y="18" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="7" y="19" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="6" y="20" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="5" y="21" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="4" y="22" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="3" y="23" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="2" y="24" class="s-3" fill="currentColor" width="1" height="1" />
      <rect x="1" y="25" class="s-3" fill="currentColor" width="1" height="1" />
      <rect y="26" class="s-3" fill="currentColor" width="1" height="1" />
    </svg>
  </span>
</template>
<script>
export default {
  props: ["classes"]
};
</script>


